// 月初现金余额管理
export default {
  interestRate: {
    column: {
      businessCompany: '公司',
      interestRateCode: '利率类型',
      interestRate: '利率',
      interestEffectiveStartDays: '利率期限起始天数',
      interestEffectiveEndDays: '利率期限到期天数',
      interestEffectiveStartDate: '有效期起',
      interestEffectiveEndDate: '有效期止',
      isEnabled: '是否启用',
      gmtModified: '操作时间',
      lastModifiedBy: '操作人',
    },
    placeholder: {
      businessCompanyPlaceholder: '请选择公司',
      interestRateCodePlaceholder: '请选择利率类型',
      interestRatePlaceholder: '请输入利率',
      interestEffectiveStartDatePlaceholder: '请选择有效期起',
      interestEffectiveEndDatePlaceholder: '请选择有效期止',
    },
    button: {
      save: '保存',
      add: '新增',
      delete: '删除',
    },
    message: {
      noSelected: '您还未选择任何数据!',
      noForbid: '失效状态不能编辑！',
      onlyOneSelectData: '请选择一条数据进行操作!',
      noExport: '当前没有数据可以导出！',
      saveSussess: '保存成功！',
      saveFail: '保存失败！',
      select: '请选择一条数据操作，或直接点击行数据编辑',
    },
    msg: {
      noData: '没有数据!',
      cancelled: '已取消',
      deleteSuccess: '删除成功！',
    },
  },
};
